import React from 'react'

export type LoaderProps = {
  size?: 'fullscreen' | 'fill-container'
}

export const Loader: React.FC<LoaderProps> = ({ size = 'fullscreen' }) => {
  const classNames = `w-full z-50 overflow-hidden flex items-center justify-center ${
    size === 'fullscreen' ? 'fixed top-0 left-0 right-0 bottom-0 h-screen' : 'h-full'
  }`

  return (
    <div className={classNames}>
      <div className="loader ease-linear"></div>
    </div>
  )
}
